import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {RcfaSummaryChartContainer} from '@widgets/downtime-analytics'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const RcfaWeeklySummaryContainer = ({plantId, cardBoxSx, placeholderWrapperSx}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezone = useUpmPlantTimezone(plantId)
  const startOfToday = moment.utc().tz(timezone).startOf('day')
  const endOfToday = startOfToday.clone().endOf('day').toISOString()
  const last7days = startOfToday.clone().subtract(7, 'day').toISOString()

  return (
    <RcfaSummaryChartContainer
      cardBoxSx={cardBoxSx}
      placeholderWrapperSx={placeholderWrapperSx}
      plantId={plantId}
      from={last7days}
      to={endOfToday}
      timeRangeLabel={t('rcfaSummary.label.last7days')}
    />
  )
}
